<script>
import * as AdaptiveCards from 'adaptivecards'
import { mapState } from 'vuex'
import Spinner from '@/components/general/spinner.vue'

export default {
  components: { Spinner },

  data: function () {
    return {
      loading: false,
    }
  },

  computed: {
    ...mapState('releases', ['adaptiveCard', 'preview']),
  },

  async mounted() {
    this.loading = true
    await this.injectHtmlRenderer()
    await this.loadAdaptiveCard()
    this.loading = false
  },
  beforeDestroy() {
    // Remove the script element when the component is destroyed
    const script = document.querySelector(
      'script[src="https://unpkg.com/markdown-it/dist/markdown-it.min.js"]'
    )
    if (script) {
      script.remove()
    }
  },

  methods: {
    async loadAdaptiveCard() {
      await this.$store.dispatch('releases/getAdaptiveCard', this.preview)
      const adaptiveCard = new AdaptiveCards.AdaptiveCard()
      adaptiveCard.parse(this.adaptiveCard)

      const cardContainer = document.getElementById('AdaptiveCard')

      // Check if there's already an adaptive card rendered and remove it
      if (cardContainer.firstChild) {
        cardContainer.removeChild(cardContainer.firstChild)
      }

      adaptiveCard.render(cardContainer)
    },

    injectHtmlRenderer() {
      // easiest way to get adaptive card to resolve the markdown, npm packages did not work
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = 'https://unpkg.com/markdown-it/dist/markdown-it.min.js'
        script.onload = resolve
        script.onerror = reject
        document.body.appendChild(script)
      })
    },
  },
}
</script>

<template>
  <v-container class="w-full">
    <h1
      >Adaptive Card
      <span
        ><v-btn
          :loading="loading"
          depressed
          color="primary"
          class="ml-2"
          @click="loadAdaptiveCard"
          ><v-icon>mdi-autorenew</v-icon></v-btn
        ></span
      ></h1
    >
    <v-container v-show="!loading">
      <div id="AdaptiveCard" class="h-full"></div>
    </v-container>
    <Spinner v-if="loading" class="mt-10" size="40" />
  </v-container>
</template>
